import React from 'react';
import { segmentService } from '../services/segmentService';
import { formatCompactNumber } from '../utils/format';
import SegmentBuilder from '../components/audience/SegmentBuilder';
import Modal from '../components/ui/Modal';
import ConfirmDialog from '../components/ui/ConfirmDialog';
import Icon from '../components/ui/Icon';
import EventBus from '../utils/EventBus';
import styles from './Segments.module.css';

class Segments extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, segments: [], modalOpen: false, editingSegment: null, confirmDeleteSeg: null, deleting: false };
    this.loadSegments = this.loadSegments.bind(this);
    this.confirmRemove = this.confirmRemove.bind(this);
  }

  componentDidMount() {
    this.loadSegments();
  }

  loadSegments() {
    this.setState({ loading: true });
    segmentService.getAll()
      .then((segments) => this.setState({ loading: false, segments }))
      .catch(() => this.setState({ loading: false }));
  }

  confirmRemove() {
    const seg = this.state.confirmDeleteSeg;
    this.setState({ deleting: true });
    segmentService.remove(seg.id)
      .then(() => {
        this.setState({ deleting: false, confirmDeleteSeg: null });
        this.loadSegments();
      })
      .catch((err) => {
        this.setState({ deleting: false, confirmDeleteSeg: null });
        EventBus.emit('toast', { type: 'error', message: err.message || 'Failed to delete segment.' });
      });
  }

  render() {
    const { loading, segments, modalOpen, confirmDeleteSeg, deleting } = this.state;

    return (
      <>
        <div className={styles.pageHead}>
          <div>
            <div className={styles.pageTitle}>Segments</div>
            <div className={styles.pageSub}>Audience segments, evaluated on demand</div>
          </div>
          <button className={styles.newBtn} onClick={() => this.setState({ modalOpen: true, editingSegment: null })}>
            + New Segment
          </button>
        </div>

        <div className={styles.grid}>
          {loading
            ? [0, 1, 2, 3, 4, 5].map((i) => (
                <div key={i} className={styles.cardSk}>
                  <div style={{ height: 120, background: 'var(--s3)', borderRadius: 8 }} />
                </div>
              ))
            : segments.map((seg) => (
                <div key={seg.id} className={styles.card}>
                  <div className={styles.cardTop}>
                    <div className={styles.segName}>{seg.name}</div>
                  </div>
                  <div className={styles.segCnt}>{formatCompactNumber(seg.user_count)}</div>
                  <div className={styles.segDesc}>
                    {seg.description || `${seg.conditions?.length || 0} condition(s) · match ${seg.match_type}`}
                  </div>
                  <div className={styles.cardActions}>
                    <button className={styles.editBtn} onClick={() => this.setState({ modalOpen: true, editingSegment: seg })}>
                      View / Edit
                    </button>
                    <button className={styles.editBtn} onClick={(e) => { e.stopPropagation(); this.setState({ confirmDeleteSeg: seg }); }}>
                      Delete
                    </button>
                  </div>
                </div>
              ))
          }
          {!loading && segments.length === 0 && (
            <div className={styles.pageSub}>No segments yet — create one to get started.</div>
          )}
        </div>

        <Modal
          open={modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
          width="740px"
          closable={false}
          bodyPadding={false}
        >
          <div className={styles.mHead}>
            <div className={styles.mIco}>
              <Icon name="group" size={20} />
            </div>
            <div className={styles.mHeadInfo}>
              <div className={styles.mTitle}>{this.state.editingSegment ? this.state.editingSegment.name : 'New Segment'}</div>
              <div className={styles.mSub}>Define audience conditions and save</div>
            </div>
            <button className={styles.mClose} onClick={() => this.setState({ modalOpen: false })}>
              <Icon name="close" size={18} />
            </button>
          </div>

          <div className={styles.mBody}>
            <SegmentBuilder
              standalone
              initialSegment={this.state.editingSegment}
              onSaved={() => {
                this.setState({ modalOpen: false });
                this.loadSegments();
              }}
            />
          </div>

          <div className={styles.mFoot}>
            <button className={styles.ghostBtn} onClick={() => this.setState({ modalOpen: false })}>
              Close
            </button>
          </div>
        </Modal>

        <ConfirmDialog
          open={!!confirmDeleteSeg}
          title="Delete segment?"
          message={confirmDeleteSeg ? `"${confirmDeleteSeg.name}" will be removed from your segment list. This won't affect any campaigns that already used it.` : ''}
          confirmLabel="Delete"
          loading={deleting}
          onConfirm={this.confirmRemove}
          onCancel={() => this.setState({ confirmDeleteSeg: null })}
        />
      </>
    );
  }
}

export default Segments;
